module.exports = __webpack_public_path__ + "img/09.13243dce.jpg";